/* Free Drop: real portal capture, fixed Lovers reading, email only. */
(() => {
  'use strict';
  if (customElements.get('cosmic-free-drop')) return;
  const teaser = 'A connection is only part of this card’s story. The choice underneath it is where things get interesting.';
  class CosmicFreeDrop extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.chosen = this.chosen ?? null;
      this.phase = this.phase || 'draw';
      this.timerEnabled = this.dataset.timerEnabled === 'true';
      this.storageKey = `cosmicmonica:free-drop:${this.dataset.campaign || 'v1'}`;
      const duration = Math.max(1, Math.min(30, Number(this.dataset.minutes) || 4)) * 60000;
      if (!this.deadline) {
        let saved;
        try { saved = Number(localStorage.getItem(this.storageKey)); } catch (_) { /* Storage may be unavailable. */ }
        this.deadline = Number.isFinite(saved) && saved > 0 ? saved : Date.now() + duration;
        try { localStorage.setItem(this.storageKey, String(this.deadline)); } catch (_) { /* Keep this page's deadline. */ }
      }
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.click(event), { signal });
      this.addEventListener('submit', event => { if (event.target.matches('[data-claim-form]')) { event.preventDefault(); this.submit(); } }, { signal });
      this.addEventListener('input', event => {
        if (!event.target.matches('input,textarea')) return;
        this.fieldError(event.target.name, '');
        this.showError('');
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input') && event.target.form) { event.preventDefault(); this.submit(); }
      }, { signal });
      this.setPhase(this.phase);
      this.setBusy(false);
      this.clock = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.request?.abort(); this.request = null;
      clearTimeout(this.requestTimeout); clearInterval(this.clock);
      this.busy = false;
    }
    $(selector) { return this.querySelector(selector); }
    all(selector) { return this.querySelectorAll(selector); }
    event(name, details = {}) {
      window.dataLayer = window.dataLayer || [];
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, funnel: 'free_drop', ...details });
    }
    announce(message) { this.$('[data-status]').textContent = message; }
    closed() {
      return (this.timerEnabled && Date.now() >= this.deadline) || (this.dataset.scarcityEnabled === 'true' && Number(this.dataset.remaining) <= 0);
    }
    tick() {
      if (!this.isConnected) return;
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.all('[data-minutes]').forEach(el => { el.textContent = String(Math.floor(seconds / 60)).padStart(2, '0'); });
      this.all('[data-seconds]').forEach(el => { el.textContent = String(seconds % 60).padStart(2, '0'); });
      this.all('[data-clock]').forEach(el => { el.dataset.low = String(seconds <= 60); });
      if (!this.busy && this.closed() && !['closed', 'waitlist', 'result'].includes(this.phase)) {
        if (this.phase === 'claim') this.setPhase('claim'); else this.setPhase('closed');
      }
      const retrying = Date.now() < (this.retryAt || 0);
      if (!this.busy) this.$('[data-submit]').disabled = retrying;
      if (retrying) this.$('[data-submit-label]').textContent = `Try again in ${Math.ceil((this.retryAt - Date.now()) / 1000)}s`;
      else if (!this.busy) this.$('[data-submit-label]').textContent = this.waitlist ? 'Get my next-drop invitation' : 'Reveal what my card means';
    }
    click(event) {
      const button = event.target.closest('button');
      const upsell = event.target.closest('[data-upsell]');
      if (upsell) this.event('upsell_clicked', { cohort: this.cohort || 'new' });
      if (!button || !this.contains(button) || button.disabled || this.busy) return;
      if (button.hasAttribute('data-card')) {
        if (this.closed()) { this.setPhase('closed'); return; }
        this.chosen = Number(button.dataset.card);
        this.all('[data-card]').forEach(card => { const chosen = Number(card.dataset.card) === this.chosen; card.setAttribute('aria-pressed', String(chosen)); card.querySelector('.cfd-yours').hidden = !chosen; });
        this.$('[data-next]').disabled = false;
        this.$('[data-next-label]').textContent = 'Reveal what my card means';
        this.$('[data-pick]').textContent = teaser;
        this.announce(`Card ${this.chosen + 1} selected. ${teaser}`);
        this.event('card_drawn', { position: this.chosen });
      } else if (button.hasAttribute('data-next') || button.hasAttribute('data-waitlist')) {
        if (this.chosen === null && !this.closed()) return;
        this.setPhase('claim', true); this.event('form_viewed', { waitlist: this.waitlist });
      } else if (button.hasAttribute('data-back')) this.setPhase(this.closed() ? 'closed' : 'draw', true);
    }
    setPhase(phase, focus = false) {
      this.phase = phase;
      this.all('[data-view]').forEach(view => { view.hidden = view.dataset.view !== phase; });
      if (phase === 'claim') {
        this.waitlist = this.closed();
        this.$('[data-claim-eyebrow]').textContent = this.waitlist ? 'Get first access' : 'You’ve chosen. Now look closer.';
        this.$('[data-claim-title]').textContent = this.waitlist ? 'What will your next card reveal?' : 'What’s beneath the card you chose?';
        this.$('[data-claim-lead]').textContent = this.waitlist ? 'This drop has closed. Leave your details to register your interest in the next free reading.' : 'There’s more to this card than its name. Enter your details to reveal it and receive your personal reading by email.';
        this.$('[data-summary-title]').textContent = this.waitlist ? 'First access to the next drop' : 'A glimpse of what’s inside';
        this.$('[data-summary-copy]').textContent = this.waitlist ? 'A new card. Another side of the story.' : teaser;
        this.$('[data-claim-micro]').textContent = this.waitlist ? 'A new drop. A fresh perspective.' : '100% free · No payment details';
        this.$('[data-view="claim"]').querySelectorAll('[data-clock]').forEach(el => { el.hidden = this.waitlist; });
      }
      const ribbon = phase === 'result' ? 'YOUR CARD. THE MESSAGE REVEALED.' : phase === 'waitlist' ? 'YOUR NEXT CHAPTER STARTS HERE' : phase === 'closed' ? 'THIS FREE READING DROP HAS CLOSED' : phase === 'claim' ? (this.waitlist ? 'GET FIRST ACCESS TO THE NEXT DROP' : `FINAL STEP${this.dataset.scarcityEnabled === 'true' ? ` · ${this.dataset.remaining} FREE READINGS LEFT` : ''}`) : `FREE READING DROP${this.timerEnabled ? ' · TODAY ONLY' : ''}`;
      this.$('[data-ribbon]').textContent = ribbon;
      if (focus) {
        const target = this.$(`[data-view="${phase}"] h1`);
        if (target) { if (target.tagName === 'H1') target.tabIndex = -1; target.focus({ preventScroll: true }); }
        this.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    fieldError(name, message) {
      const field = this.$(`[name="${name}"]`), error = this.$(`[data-field-error="${name}"]`);
      if (!field || !error) return;
      field.setAttribute('aria-invalid', String(Boolean(message))); error.textContent = message; error.hidden = !message;
    }
    showError(message) { const el = this.$('[data-submit-error]'); el.textContent = message; el.hidden = !message; }
    setBusy(busy) {
      this.busy = busy; this.setAttribute('aria-busy', String(busy));
      this.all('input,textarea,[data-back],[data-submit]').forEach(el => { el.disabled = busy; });
      this.$('[data-submit-label]').textContent = busy ? 'Saving your request…' : this.waitlist ? 'Get my next-drop invitation' : 'Reveal what my card means';
      if (!busy) this.tick();
    }
    async submit() {
      if (this.busy || this.phase !== 'claim' || Date.now() < (this.retryAt || 0)) return;
      this.showError('');
      const form = this.$('[data-claim-form]');
      const name = form.elements.name.value.trim(), email = form.elements.email.value.trim(), question = form.elements.question.value.trim();
      const nameError = name ? '' : 'Please enter your first name.';
      const emailError = email && form.elements.email.validity.valid && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? '' : 'Please enter a valid email address.';
      this.fieldError('name', nameError); this.fieldError('email', emailError);
      if (nameError || emailError) { form.elements[nameError ? 'name' : 'email'].focus(); return; }
      if (!this.waitlist && this.closed()) { this.setPhase('claim'); this.tick(); this.announce('This drop has closed. You can register for the next drop.'); return; }
      const waitlist = this.waitlist;
      // The existing leads API appends questions to Customer.metadata.ctaQuestions.
      // Include the explicit request even without a question so existing contacts
      // retain their next-drop interest as well as newly created prospects.
      const interest = `Free Drop next-drop invitation requested (campaign: ${this.dataset.campaign || 'v1'}).${question ? `\nQuestion: ${question}` : ''}`;
      const payload = waitlist ? { email, name, consentSource: 'free_drop_waitlist', questions: interest } : { email, name, ...(question ? { question } : {}) };
      this.event(waitlist ? 'free_drop_waitlist_submitted' : 'signup_submitted');
      this.setBusy(true);
      const lifecycle = this.controller;
      this.request = new AbortController();
      this.requestTimeout = setTimeout(() => this.request?.abort(), 25000);
      try {
        const base = new URL(this.dataset.portalBase || 'https://portal.1727labs.com');
        if (base.protocol !== 'https:') throw new Error('Portal must use HTTPS');
        const response = await fetch(new URL(`/api/${waitlist ? 'leads' : 'free-reading'}/cosmicmonica`, base), {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
          body: JSON.stringify(payload), signal: this.request.signal
        });
        if (!this.isConnected || this.controller !== lifecycle) return;
        if (response.status === 429) {
          const header = response.headers.get('Retry-After');
          const seconds = /^\d+$/.test(header || '') ? Number(header) : 60;
          this.retryAt = Date.now() + Math.min(3600, Math.max(1, seconds)) * 1000;
          this.showError('A few requests arrived together. Please wait a moment and try again.'); return;
        }
        if (response.status === 400) { this.fieldError('email', 'Please check your email address and try again.'); return; }
        if (!response.ok) throw new Error('Capture failed');
        const body = await response.json();
        if (waitlist ? body?.success !== true || typeof body.customerId !== 'string' || !body.customerId : typeof body?.freeReadingId !== 'string' || !body.freeReadingId) throw new Error('Capture was not confirmed');
        this.cohort = ['new', 'lapsed', 'active'].includes(body.cohort) ? body.cohort : 'new';
        const first = name.split(/\s+/)[0];
        if (waitlist) {
          this.$('[data-waitlist-title]').textContent = `${first}, you’re on the list.`;
          this.setPhase('waitlist', true); this.event('free_drop_waitlist_succeeded');
        } else {
          this.$('[data-result-title]').textContent = `${first}, you drew The Lovers.`;
          this.$('[data-confirm]').textContent = body.duplicate ? 'You’ve already requested your free reading. Look out for Monica’s email, or check your inbox if it has already arrived.' : 'Your request is saved. Monica’s personal reading will follow by email. Here’s a first look at your card.';
          this.$('[data-reading-delivery]').textContent = body.duplicate ? 'Your personal reading belongs to the request you already made. Look out for it by email.' : 'That’s the opening. Your personal reading will explore your question more closely by email.';
          this.$('[data-question-text]').textContent = question;
          this.$('[data-question-recap]').hidden = !question || Boolean(body.duplicate);
          this.setPhase('result', true);
          this.event('signup_succeeded', { cohort: this.cohort, duplicate: Boolean(body.duplicate) });
          if (this.$('[data-paid-offer]')) this.event('upsell_presented', { cohort: this.cohort, placement: 'confirmation' });
        }
        this.announce(waitlist ? 'Your interest is saved.' : body.duplicate ? 'Your free reading was already requested.' : 'Your free reading request is saved.');
      } catch (_) {
        if (this.isConnected && this.controller === lifecycle) this.showError('We couldn’t confirm your request. Your details are still here. Please try again.');
      } finally {
        if (this.controller === lifecycle) {
          clearTimeout(this.requestTimeout); this.request = null;
          if (this.isConnected) this.setBusy(false);
        }
      }
    }
  }
  customElements.define('cosmic-free-drop', CosmicFreeDrop);
})();
